if ($('.id--16, .id--17').length) {
    $('.cart-inner').prepend($('.cart-header'));
    $('#checkoutContent').append($('.next-step .next-step-back').clone());
    $('#checkoutSidebar').append($('.next-step .next-step-back').clone());
}
if ($('.id--16').length) {
    $(document).ready(function () {
        
        $('#orderFormButton span').text(translation('continueInOrder'));
    });
}

if ($('.id--9').length) {


    $(document).ready(function () {
        if ($('.cart-empty').length) {
            $('.cart-heading').after('<div class="text-center"><a href="/" class="btn btn-primary">' + translation('zpetdoobchodu') + '</a></div>')
        }
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            if ($('.cart-empty').length) {
                $('.cart-heading').after('<div class="text-center"><a href="/" class="btn btn-primary">' + translation('zpetdoobchodu') + '</a></div>')
            }
        });
    });





    function mhProductInfoMove() {

        $('.cart-table tr').each(function () {
            var findcenazakus = $(this).find('.p-price.p-cell').html();
            var findptotal = $(this).find('.p-total');
            $(this).find('.p-name').append('<div class="avail">' + $(this).find('.p-availability').html() + '</div>');
            $(findptotal).prepend('<span class="cenazaks">' + findcenazakus + '</span>');
        });
        if ($('.cart-table .p-discount').length) {
            $('.cart-table ').prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">${translation('cartProdukt')}</th>
                    <th class="avail">${translation('cartDostupnost')}</th>
                    <th class="qty">${translation('cartPocet')}</th>
                    <th class="unit">${translation('cartPcartCenaZaKusrodukt')}</th>
                    <th class="sale">${translation('cartsleva')}</th>
                    <th class="total">${translation('cartCelkem')}</th>
                </tr>
                    </thead>
            `);
        }
        else {
            $('.cart-table ').prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">${translation('cartProdukt')}</th>
                    <th class="avail">${translation('cartDostupnost')}</th>
                    <th class="qty">${translation('cartPocet')}</th>
                    <th class="unit">${translation('cartCenaZaKus')}</th>
                    <th class="total">${translation('cartCelkem')}</th>
                </tr>
                    </thead>
            `);
        }

        $('.sidebar-in-cart').prepend($('.cart-summary'));
        $('.cart-summary').append($('.summary-wrapper .next-step-back').clone());
        $('.summary-wrapper').after($('.summary-wrapper .next-step-back').clone());
        $('#continue-order-button span').text(translation('continueInOrder'));




    };
    $(document).ready(function () {
        mhProductInfoMove();

    });
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}


function initZaslat() {
    loadScript('https://app.zaslat.cz/map/shoptet.js', function () {
        console.log('Zaslat script načten');
    });
}

function loadScript(src, callback) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = callback;
    document.head.appendChild(s);
}

$(document).ready(function () {
    initZaslat();
});
